import type { DocumentNode, GraphQLSchema } from 'graphql';
import { makeExecutableSchema } from '@graphql-tools/schema';
import type { Resolvers as AfterEffectsResolvers } from './aftereffects/generated';
import type { Resolvers as PremiereResolvers } from './premierepro/generated';

let _schema: GraphQLSchema;

export type InitializeExecutableSchemaArgs =
  | {
      hostApp: 'aftereffects';
      resolvers: Partial<AfterEffectsResolvers>;
      typeDefs: DocumentNode;
    }
  | {
      hostApp: 'premierepro';
      resolvers: Partial<PremiereResolvers>;
      typeDefs: DocumentNode;
    };

export const initializeExecutableSchema = ({
  typeDefs,
  resolvers,
}: InitializeExecutableSchemaArgs) => {
  if (!_schema) {
    _schema = makeExecutableSchema({
      typeDefs,
      resolvers: {
        ...resolvers,
      },
      resolverValidationOptions: {
        requireResolversForAllFields: 'ignore',
        requireResolversToMatchSchema: 'warn',
      },
    });
  } else {
    throw new Error('Schema already initialized');
  }
};

export const getExecutableSchema = (): GraphQLSchema => {
  if (!_schema) {
    throw new Error('Schema not initialized');
  }
  return _schema;
};

export const resetExecutableSchema = (): void => {
  _schema = undefined as any;
};
